class Dropdown {
	constructor(element) {
		this.element = element;
		this.trigger = element.querySelector('.js-dropdown__trigger');
		this.dropdown = element.querySelector('.js-dropdown__menu');
		this.hoverTimeout = null;
		this.isHovering = false;

		this.initEvents();
	}

	initEvents() {
		this.trigger.addEventListener('mouseenter', () => this.handleHover(true));
		this.trigger.addEventListener('mouseleave', () => this.handleHover(false));

		this.dropdown.addEventListener('mouseenter', () => this.handleHover(true));
		this.dropdown.addEventListener('mouseleave', () => this.handleHover(false));
	}

	handleHover(isHovering) {
		this.isHovering = isHovering;
		clearTimeout(this.hoverTimeout);

		if (isHovering) {
			this.showDropdown();
		} else {
			this.hoverTimeout = setTimeout(() => {
				if (!this.isHovering) {
					this.hideDropdown();
				}
			}, 100);
		}
	}

	showDropdown() {
		this.dropdown.classList.add('dropdown__menu--is-visible');
		this.dropdown.classList.remove('dropdown__menu--hide');

		// Add active class to body for overlay
		document.body.classList.add('active');
	}

	hideDropdown() {
		this.dropdown.classList.add('dropdown__menu--hide');
		this.dropdown.classList.remove('dropdown__menu--is-visible');

		// Remove active class from body
		if (!document.querySelector('.js-dropdown__menu.dropdown__menu--is-visible')) {
			document.body.classList.remove('active');
		}
	}
}

// Initialize all dropdowns
const dropdowns = document.querySelectorAll('.js-dropdown');
dropdowns.forEach(dropdown => new Dropdown(dropdown));
